// extracted by mini-css-extract-plugin
export default {"authLayout":"auth_authLayout__GEQZ1","layoutWrapper":"auth_layoutWrapper__hIAH1"};